export enum CustomControlCode {
    BariPostAddToMdo = 'BariPostAddToMdo',
    BariPostCaroBodyWeightMeasurements = 'BariPostCaroBodyWeightMeasurements',
    BariPostCaroBodyWeightMeasurementsInactiveNotification = 'BariPostCaroBodyWeightMeasurementsInactiveNotification',
    BariPostCaroInactivityLifestyleCoachReport = 'BariPostCaroInactivityLifestyleCoachReport',
    BariPostCaroInactivityPoliReport = 'BariPostCaroInactivityPoliReport',
    BariPostCaroInactivitySecretarialAssistantReport = 'BariPostCaroInactivitySecretarialAssistantReport',
    BariPostCaroQuestionnaireResponse = 'BariPostCaroQuestionnaireResponse',
    BariPostCaroQuestionnaireResponsesInactiveNotification = 'BariPostCaroQuestionnaireResponsesInactiveNotification',
    BariPostDietConsultReport = 'BariPostDietConsultReport',
    BariPostDietitianReport = 'BariPostDietitianReport',
    BariPostDietPlanAppointment = 'BariPostDietPlanAppointment',
    BariPostEnrollment = 'BariPostEnrollment',
    BariPostFollowUpBodyWeightMeasurements = 'BariPostFollowUpBodyWeightMeasurements',
    BariPostLifestyleCoachReport = 'BariPostLifestyleCoachReport',
    BariPostMdoReport = 'BariPostMdoReport',
    BariPostNote = 'BariPostNote',
    BariPostNurseSpecialistFollowUp = 'BariPostNurseSpecialistFollowUp',
    BariPostNurseSpecialistReferral = 'BariPostNurseSpecialistReferral',
    BariPostNurseSpecialistReport = 'BariPostNurseSpecialistReport',
    BariPostPoliReport = 'BariPostPoliReport',
    BariPostPsychologistReport = 'BariPostPsychologistReport',
    BariPostSecretarialAssistentFollowUp = 'BariPostSecretarialAssistentFollowUp',
    BariPostSurgeryDate = 'BariPostSurgeryDate',
    BariPostTreatmentReport = 'BariPostTreatmentReport',
    BariPreAddGeneralPractitioner = 'BariPreAddGeneralPractitioner',
    BariPreAddToMdo = 'BariPreAddToMdo',
    BariPreCaroAccountNotActivatedNotification = 'BariPreCaroAccountNotActivatedNotification',
    BariPreCaroInactivityPoliReport = 'BariPreCaroInactivityPoliReport',
    BariPreCloseProcessPrematurely = 'BariPreCloseProcessPrematurely',
    BariPreDietPlanAppointment = 'BariPreDietPlanAppointment',
    BariPreDietScreening = 'BariPreDietScreening',
    BariPreExternalReferral = 'BariPreExternalReferral',
    BariPreGroupSession = 'BariPreGroupSession',
    BariPreMdoInterimReport = 'BariPreMdoInterimReport',
    BariPreMdoReport = 'BariPreMdoReport',
    BariPreMedConsultAssessment = 'BariPreMedConsultAssessment',
    BariPreMedConsultExamResults = 'BariPreMedConsultExamResults',
    BariPreMedConsultPlanAppointment = 'BariPreMedConsultPlanAppointment',
    BariPreMedConsultReport = 'BariPreMedConsultReport',
    BariPreNote = 'BariPreNote',
    BariPreNurseSpecialistMedScreeningReport = 'BariPreNurseSpecialistMedScreeningReport',
    BariPrePsychQuestionnaire = 'BariPrePsychQuestionnaire',
    BariPrePsychScreening = 'BariPrePsychScreening',
    BariPreReferral = 'BariPreReferral',
    BariPreResumeMdo = 'BariPreResumeMdo',
    BariPreResumeMdoInterim = 'BariPreResumeMdoInterim',
    BariPreSecretarialAssistentMedScreeningReport = 'BariPreSecretarialAssistentMedScreeningReport',
    EchographyAdditionalQuestionRequest = 'EchographyAdditionalQuestionRequest',
    EchographyAdditionalQuestionResponse = 'EchographyAdditionalQuestionResponse',
    EchographyConsultRequest = 'EchographyConsultRequest',
    EchographyConsultResponse = 'EchographyConsultResponse',
    HeadacheAssessment = 'HeadacheAssessment',
    HeadacheExamination = 'HeadacheExamination',
    HeadacheReferral = 'HeadacheReferral',
    HearingLossAssessment = 'HearingLossAssessment',
    HearingLossAudiologistConsult = 'HearingLossAudiologistConsult',
    HearingLossAudiologistFollowUpConsult = 'HearingLossAudiologistFollowUpConsult',
    HearingLossExamination = 'HearingLossExamination',
    HolterAnalysisReport = 'HolterAnalysisReport',
    HolterConfigure = 'HolterConfigure',
    HolterConsult = 'HolterConsultationReply',
    HolterConsultPayment = 'HolterConsultPayment',
    HolterConsultRequest = 'HolterManualConsultationRequest',
    HolterDiaryUpload = 'HolterDiaryUpload',
    HolterDirectExaminationRequest = 'HolterDirectExaminationRequest',
    HolterExternalExaminationRequest = 'HolterExternalExaminationRequest',
    HolterFollowUpConsultRequest = 'HolterFollowUpConsultRequest',
    HolterGrading = 'HolterGrading',
    HolterHomeExaminationRequest = 'HolterHomeExaminationRequest',
    HolterReadOut = 'HolterReadOut',
    HolterSecondRoundAnswer = 'HolterSecondRoundAnswer',
    HolterSecondRoundQuestion = 'HolterSecondRoundQuestion',
    HolterZorgdomeinExaminationRequest = 'HolterZorgdomeinExaminationRequest',
    LumbarRadiculopathyAssessment = 'LumbarRadiculopathyAssessment',
    LumbarRadiculopathyExamination = 'LumbarRadiculopathyExamination',
    LumbarRadiculopathyReferral = 'LumbarRadiculopathyReferral',
    OSASAuthorizeOrganization = 'OSASAuthorizeOrganization',
    OSASCloseUnfinishedExamination = 'OSASCloseUnfinishedExamination',
    OSASCloseUnfinishedFollowUpExamination = 'OSASCloseUnfinishedFollowUpExamination',
    OSASCloudPatExamination = 'OSASCloudPatExamination',
    OSASCloudPatFollowUpExamination = 'OSASCLoudPatFollowUpExamination',
    OSASConsult = 'OSASConsult',
    OSASCPAPChosen = 'OSASCPAPChosen',
    OSASEvaluation = 'OSASEvaluation',
    OSASExternalReferralLetter = 'OSASExternalReferralLetter',
    OSASFollowUpConsult = 'OSASFollowUpConsult',
    OSASLifestyleForm = 'OSASLifestyleForm',
    OSASMijnKsyosEssQuestionnaire = 'OSASMijnKsyosEssQuestionnaire',
    OSASMijnKsyosHsdqQuestionnaire = 'OSASMijnKsyosHsdqQuestionnaire',
    OSASMraLetter = 'OSASMraLetter',
    OSASNote = 'OSASNote',
    OSASReferral = 'OSASReferral',
    OSASRequestAdditionalExamination = 'OSASRequestAdditionalExamination',
    OSASRequestFollowUpExamination = 'OSASRequestFollowUpExamination',
    OSASResendMijnKsyosPatientInvite = 'OSASResendMijnKsyosPatientInvite',
    OSASResendMijnKsyosQuestionnaires = 'OSASResendMijnKsyosQuestionnaires',
    OSASShowMijnKsyosQuestionnairesInClientsafe = 'OSASShowMijnKsyosQuestionnaires',
    OSASTreatmentChoice = 'OsasTreatmentChoice',
    OSASZorgDomeinReferral = 'OSASZorgDomeinReferral',
    RespiAllerDecisionTree = 'RespiAllerDecisionTree',
    RespiAllerGrading = 'RespiAllerGrading',
    RespiAllerGradingDataV1 = 'RespiAllerGradingDataV1',
    RespiAllerPrickTestMeasurements = 'RespiAllerPrickTestMeasurements',
    RespiAllerQuestionnaire = 'RespiAllerQuestionnaire',
    RespiAllerQuestionnaireStatus = 'RespiAllerQuestionnaireStatus',
    RespiAllerReferral = 'RespiAllerReferral',
    RespiAllerResendQuestionnaire = 'RespiAllerResendQuestionnaire',
    TPCFlexAnswer = 'TPCFlexAnswer',
    TPCFlexClarificationAnswer = 'TPCFlexClarificationAnswer',
    TPCFlexClarificationQuestion = 'TPCFlexClarificationQuestion',
    TPCFlexRequest = 'TPCFlexRequest',
    TPOFlexBiometry = 'TPOFlexBiometry',
    TPOFlexGrading = 'TPOFlexGrading',
    TPOFlexRequest = 'TPOFlexRequest',
    TPOFlexSupervisionGrading = 'TPOFlexSupervisionGrading',
    TPOFlexSupervisionProcedure = 'TPOFlexSupervisionProcedure',
}
